import React, { useMemo } from "react";
import {
  CaretUpFilled,
  CaretDownFilled,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "antd";
import {
  setSelectedDeepdiveWidget,
  setisDeepDive,
} from "../../redux/actions/dashboard/Tab1";
import {
  getAllFilters,
  getBrands,
  getCustomizedDate,
  getGlobalBrands,
  getPaneIndex,
  getWindowLocationPath,
  kFormatter,
  useQuery,
} from "../../redux/constants";
import moment from "moment";
import {
  setDeepDiveInfoLoader,
  setIsDetailedInsightVisible,
  setTabClick,
} from "../../redux/actions/DeepDive";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
  set_WM_DeepDive,
} from "../../redux/actions/WidgetMaker/WidgetMaker";
import { getDeepDive } from "../../redux/actions/WidgetMaker/WidgetAPI";
import defaultImage from "../../assets/brandLogos/Default_Brand.svg";
import isEqual from "react-fast-compare";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { isString } from "highcharts";
import { setShareSelectedDeepdiveWidget } from "../../redux/actions/share/Share";
import { Collapse } from "antd";
import KpiCards from "./KpiCards";

const { Panel } = Collapse;

const CardList = ({
  metaWidgetKpiData,
  widgetGraphConfig,
  count,
  cardPosition,
  widgetShareOfData,
  widgetDurationComparison,
  type,
  dashboard,
  PdfDownloadStatus,
  ppt_generating_status,
  widget_index,
  section_index,
  noteExist,
  metaWidgetConfig,
  isPreviewState,
}) => {
  const dispatch = useDispatch();

  let query = useQuery();
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);

  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const widgetGraphConfigState = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  let widget_metadata =
    section_index >= 0
      ? panes[getPaneIndex(panes, activeKey)]?.sections?.[section_index]
          ?.widgets?.[widget_index]
      : panes[getPaneIndex(panes, activeKey)]?.section?.[0]?.widgets?.[
          widget_index
        ];

  let deepdiveTypes = widget_metadata?.chart?.chart_settings?.cards_settings
    ?.filter((e) => e?.x_axis)
    ?.map((el) => el?.x_axis?.attribute);

  const handleKpiDeepdive = (e, data) => {
    if (panes[getPaneIndex(panes, activeKey)]?.isDashboard || shareBrands) {
      let pathName = getWindowLocationPath()?.toLowerCase();
      let widget_ids =
        workspace_privileges?.environment === 2 ||
        share_workspace_privileges?.environment === 2
          ? ["info-bar", "2.1", "2.2", "2.3", "2.4"]
          : ["info-bar", "1.1", "1.2"];
      let index = getPaneIndex(panes, activeKey);
      let shareSections = shareTemplateData?.section
        ? shareTemplateData?.section[0]
        : shareTemplateData?.sections[section_index];
      let widget_metadata = shareBrands
        ? shareSections?.widgets?.[widget_index]
        : section_index >= 0
        ? panes[index]?.sections[section_index]?.widgets[widget_index]
        : panes[index]?.section[0]?.widgets[widget_index];

      let section_metadata = shareBrands
        ? shareSections
        : section_index >= 0
        ? panes[index]?.sections[section_index]
        : panes[index]?.section[0];
      let Section_is_locked = section_metadata?.is_locked;
      let widgets_is_locked = widget_metadata?.is_locked;
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };

      !shareBrands &&
        dispatch(
          setSelectedDeepdiveWidget(section_index, widget_index, panes, index)
        );

      shareBrands &&
        dispatch(
          setShareSelectedDeepdiveWidget({
            section_index: section_index,
            widget_index: widget_index,
          })
        );

      let global_duration = shareBrands
        ? sharedDuration?.from
          ? {
              from: sharedDuration?.from,
              to: sharedDuration?.to,
            }
          : null
        : panes[index]?.duration;

      // let global_brands = shareBrands
      //   ? shareBrands
      //   : getGlobalBrands(
      //       panes[index]?.brands,
      //       global_dashboard_single_brands,
      //       global_dashboard_brands,
      //       panes[index]?.template_type
      //     );
      let global_brands = shareBrands ? shareBrands : panes?.[index]?.brands;
      let brandIds = shareBrands
        ? widget_metadata?.brand_ids
        : section_index >= 0
        ? panes[index]?.sections[section_index]?.widgets &&
          panes[index]?.sections[section_index]?.widgets[widget_index]
            ?.brand_ids
        : panes[index]?.section[0]?.widgets[widget_index]?.brand_ids
        ? panes[index]?.section[0]?.widgets[widget_index]?.brand_ids
        : null;

      let sectionDateFilter = shareTemplateData?.sections
        ? {
            from: shareTemplateData?.sections[section_index]?.start_date
              ? shareTemplateData?.sections[section_index]?.start_date
              : null,
            to: shareTemplateData?.sections[section_index]?.end_date
              ? shareTemplateData?.sections[section_index]?.end_date
              : null,
          }
        : null;

      let widgetFilterDate = {
        from: widget_metadata?.start_date ? widget_metadata?.start_date : null,
        to: widget_metadata?.end_date ? widget_metadata?.end_date : null,
      };

      let combinedFilters = [];
      if (!widget_metadata?.is_locked) {
        if (widgetFilterDate?.from)
          combinedFilters.push({
            attribute: "CreatedDate",
            type: "datetime",
            columns: widgetFilterDate,
          });

        if (sectionDateFilter?.from && !section_metadata?.is_locked) {
          combinedFilters.push({
            attribute: "CreatedDate",
            type: "datetime",
            columns: sectionDateFilter,
          });
        }
        if (section_metadata?.brand_ids && !section_metadata?.is_locked) {
          let brands = getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          );

          combinedFilters.push(brands);
        }
        if (widget_metadata?.brand_ids) {
          let brands = getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          );

          combinedFilters.push(brands);
        }
      }

      if (widget_metadata?.filters)
        combinedFilters = [...widget_metadata?.filters, ...combinedFilters];
      if (section_metadata?.filters)
        combinedFilters = [...section_metadata?.filters, ...combinedFilters];
      let filterData = combinedFilters?.filter((d) => d);
      let hidden_filter = shareTemplateData?.hidden_filter
        ? [shareTemplateData?.hidden_filter]
        : [];
      let quick_filter = shareTemplateData?.quick_filter
        ? [shareTemplateData?.quick_filter]
        : [];

      let filter = shareBrands
        ? [...filterData, ...hidden_filter, ...quick_filter]
        : getAllFilters(
            graphConditionConfig,
            panes,
            index,
            section_index,
            widget_index,
            brandlogicalgroup,
            brandIds
          );

      let widget_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            widget_metadata?.brand_ids,
            brands,
            widget_metadata?.brand_groups
          );
      let section_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            section_metadata?.brand_ids,
            brands,
            section_metadata?.brand_groups
          );
      let defaultBrands = shareBrands ? shareBrands : null;
      // here calculating the public_engagement_only for the deepdive
      let public_engagement_only =
        pathName === "CommandCenter"?.toLowerCase()
          ? false // for now static false sending for command center
          : shareBrands
          ? shareTemplateData?.template_type === "competition"
            ? shareTemplateData?.public_engagement_only || false
            : false
          : panes?.[index]?.template_type === "competition"
          ? panes?.[index]?.public_engagement_only || false
          : false;
      let graphObject = {
        start_date: widgets_is_locked
          ? widget_metadata?.start_date
            ? widget_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? section_metadata.start_date
            ? section_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : global_duration?.from
          ? global_duration?.from
          : defaultDuration?.from,
        end_date: widgets_is_locked
          ? widget_metadata?.end_date
            ? widget_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? section_metadata?.end_date
            ? section_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : global_duration?.to
          ? global_duration?.to
          : defaultDuration?.to,
        brands: shareBrands
          ? widget_metadata?.is_locked
            ? widget_brands?.columns
              ? widget_brands?.columns
              : section_metadata?.is_locked
              ? section_brands?.columns
                ? section_brands?.columns
                : defaultBrands
              : defaultBrands
            : section_metadata?.is_locked
            ? section_brands?.columns
              ? section_brands?.columns
              : defaultBrands
            : defaultBrands
          : widgets_is_locked
          ? widget_metadata?.brand_ids || widget_metadata?.brand_groups
            ? widget_brands?.columns
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : Section_is_locked
          ? section_metadata?.brand_ids || section_metadata?.brand_groups
            ? section_brands?.columns
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : global_brands
          ? global_brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        isBrandModified:
          !shareBrands &&
          (widgets_is_locked || Section_is_locked) &&
          (section_metadata?.brand_ids ||
            section_metadata?.brand_groups ||
            widget_metadata?.brand_ids ||
            widget_metadata?.brand_groups)
            ? true
            : global_brands
            ? true
            : false,
        deepdive_on: {
          x_axis: {
            attribute: data?.attribute,
            value: data?.text?.includes("|$|")
              ? data?.text?.split("|$|")?.[1]?.trim()
              : data?.text?.includes("|G|")
              ? data?.text?.split("|G|")?.[1]?.trim()
              : data?.text?.includes("|C|")
              ? data?.text?.split("|C|")?.[1]?.trim()
              : data?.text,
            trace_name: data?.trace_name || allAttributes?.[data?.attribute],
          },
        },
        filters: filter ? filter : null,
        paneIndex: index,
        panes: panes,
        shareBrands: shareBrands,
        shareTemplateData: {
          ...shareTemplateData,
          isDeepDive: true,
          deep_dive: {
            infoBar: null,
            mentions: null,
            wordcloud: [],
            category: [],
            top_users: [],
            influencers: [],
            source_of_post: [],
            locations: [],
          },
        },
        tabName:
          workspace_privileges?.environment === 2 ||
          share_workspace_privileges?.environment === 2
            ? "Word Cloud"
            : "Mentions",
        shareCategory: shareCategory,
        filter_dropdown: widget_metadata?.payload?.filter_dropdown || [],
        filter_by_dropdown: widget_metadata?.payload?.filter_by_dropdown || [],
        public_engagement_only: public_engagement_only ? true : false,
      };

      dispatch(
        setIsDetailedInsightVisible({
          value: false,
          tab_id: null,
          name:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "Word Cloud"
              : "Mentions",
          key:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "2"
              : "1",
        })
      );

      dispatch(
        setTabClick({
          tabName:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "wordcloud"
              : "mentions",
          state: true,
        })
      );
      dispatch(setDeepDiveObject(graphObject));
      dispatch(setDeepDiveMentionsObject(graphObject));
      dispatch(setDeepDiveInfluencersObject(graphObject));
      shareTemplateData &&
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: {
            ...shareTemplateData,
            isDeepDive: true,
            deep_dive: {
              infoBar: null,
              mentions: null,
              wordcloud: [],
              category: [],
              top_users: [],
              influencers: [],
              source_of_post: [],
              locations: [],
            },
          },
        });
      !shareBrands && dispatch(setisDeepDive(true, panes, index));

      dispatch(set_WM_DeepDive(true));
      dispatch(setDeepDiveInfoLoader(true));
      dispatch(
        getDeepDive(authParams, graphObject, widget_ids, query?.get("share_id"))
      );
    }
  };

  const TooltipFormatter = (num) => {
    if (Math.abs(num)) {
      return (Math.round(num * 100) / 100).toFixed(2);
    } else return num;
  };

  const getcardData = () => {
    let cData = null;
    if (
      widgetGraphConfig?.card_settings &&
      Array.isArray(widgetGraphConfig?.card_settings) &&
      widgetGraphConfig?.card_settings?.some((card) => card?.response)
    ) {
      cData = widgetGraphConfig?.card_settings?.find(
        (card) => card?.response
      )?.response;
    }

    // let cData =
    //   widgetGraphConfig?.brands && widgetGraphConfig?.brands[0]?.competitor
    //     ? widgetGraphConfig?.card_settings &&
    //       widgetGraphConfig?.card_settings[
    //         widgetGraphConfig?.card_settings?.length - 1
    //       ]?.response
    //     : (widgetGraphConfig?.card_settings &&
    //         widgetGraphConfig?.card_settings[
    //           widgetGraphConfig?.card_settings?.length - 1
    //         ]?.x_axis?.atrribute) ||
    //       (widgetGraphConfig?.card_settings &&
    //         widgetGraphConfig?.card_settings[
    //           widgetGraphConfig?.card_settings?.length - 1
    //         ]?.y_series) ||
    //       (widgetGraphConfig?.card_settings &&
    //         widgetGraphConfig?.card_settings[
    //           widgetGraphConfig?.card_settings?.length - 1
    //         ]?.response)
    //     ? widgetGraphConfig?.card_settings &&
    //       widgetGraphConfig?.card_settings[
    //         widgetGraphConfig?.card_settings?.length - 1
    //       ]?.response
    //     : widgetGraphConfig?.card_settings &&
    //       widgetGraphConfig?.card_settings[
    //         widgetGraphConfig?.card_settings?.length - 2
    //       ]?.response;
    return cData;
  };

  const card_data = useMemo(() => getcardData(), [widgetGraphConfigState]);

  if (cardPosition == undefined) cardPosition = "";

  const isDeepDive = authParams?.screen_id
    ? screen?.isDeepDiveDashboard && !screen?.isDeepDive
      ? deepdiveDashboardTemplateData?.template_type === "deep_dive"
      : !screen?.isDeepDive
    : shareableLinkDeepDiveStatus
    ? shareTemplateData?.isDeepDiveDashboard && !shareTemplateData?.isDeepDive
      ? deepdiveDashboardTemplateData?.template_type === "deep_dive"
      : !shareTemplateData?.isDeepDive
    : panes[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard &&
      !panes[getPaneIndex(panes, activeKey)]?.isDeepDive
    ? deepdiveDashboardTemplateData?.template_type === "deep_dive"
    : !panes[getPaneIndex(panes, activeKey)]?.isDeepDive;

  const onChange = (key) => {};

  return (
    <>
      {metaWidgetKpiData?.kpi?.[0]?.data || card_data?.[0]?.data ? (
        <>
          {metaWidgetKpiData?.kpi?.length ? (
            <div
              className={`d-flex flex-wrap w-100 wm-chart-cards ${
                cardPosition === "Bottom"
                  ? "border-top border-left border-color custom_scroll1"
                  : cardPosition === "Top"
                  ? "border-left border-color custom_scroll1"
                  : ""
              } ${
                (cardPosition && cardPosition === "Left") ||
                cardPosition === "Right"
                  ? "custom_scroll1 card__list--scrollable"
                  : "justify-content-between"
              }`}
              style={
                type === "map" &&
                !dashboard &&
                (!PdfDownloadStatus || !ppt_generating_status)
                  ? { maxHeight: "calc(100vh - 16.5rem)", overflow: "auto" }
                  : PdfDownloadStatus || ppt_generating_status
                  ? { maxHeight: "68.5rem" }
                  : type !== "map" && dashboard && dashboard
                  ? ppt_generating_status
                    ? { maxHeight: "53.5rem" }
                    : cardPosition &&
                      (cardPosition === "Left" || cardPosition === "Right")
                    ? { maxHeight: "48rem" }
                    : {}
                  : {}
              }
            >
              {metaWidgetKpiData?.kpi?.map((d, i) => {
                let previousCardsCount = 0;
                if (i === 0) {
                  previousCardsCount = 0;
                } else {
                  for (let j = 0; j < i; j++)
                    previousCardsCount +=
                      metaWidgetKpiData?.kpi?.[j]?.data?.length;
                }
                if (previousCardsCount >= 15) return null;

                return (
                  <>
                    <Collapse
                      bordered={false}
                      className={`bg__white w-100 ${
                        ppt_generating_status
                          ? "border border-color"
                          : "border-0"
                      }`}
                      expandIconPosition="right"
                      defaultActiveKey={[i]}
                      onChange={onChange}
                      accordion
                      expandIcon={({ isActive }) =>
                        isActive ? <UpOutlined /> : <DownOutlined />
                      }
                    >
                      <Panel
                        className="custom_kpi w-100 border-bottom-0"
                        header={
                          <div className="text_regular font-weight500">
                            {d?.trace_name || allAttributes?.[d?.attribute]}
                          </div>
                        }
                        key={i}
                        showArrow={
                          PdfDownloadStatus || ppt_generating_status
                            ? false
                            : true
                        }
                      >
                        <div
                          className={`flex-wrap d-flex p-6 ${
                            type === "kpi" ? "bg__gray" : ""
                          } gap-6 w-100`}
                        >
                          <KpiCards
                            metaWidgetKpiData={metaWidgetKpiData}
                            widgetGraphConfig={widgetGraphConfig}
                            count={previousCardsCount}
                            cardPosition={cardPosition}
                            widgetShareOfData={widgetShareOfData}
                            widgetDurationComparison={widgetDurationComparison}
                            type={type}
                            dashboard={dashboard}
                            PdfDownloadStatus={PdfDownloadStatus}
                            ppt_generating_status={ppt_generating_status}
                            widget_index={widget_index}
                            section_index={section_index}
                            kpi_data={d?.data}
                            noteExist={noteExist}
                            metaWidgetConfig={metaWidgetConfig}
                          />
                        </div>
                      </Panel>
                    </Collapse>
                  </>
                );
              })}
            </div>
          ) : (
            ""
          )}

          {!metaWidgetKpiData && card_data?.length ? (
            <div
              className={`flex-wrap w-100 wm-chart-cards d-flex ${
                cardPosition === "Bottom" ? "border-top border-color" : ""
              } ${
                (cardPosition && cardPosition === "Left") ||
                cardPosition === "Right"
                  ? "custom_scroll1 card__list--scrollable"
                  : "justify-content-between"
              }`}
            >
              {card_data?.map((d, i) => {
                let previousCardsCount = 0;
                if (i === 0) {
                  previousCardsCount = 0;
                } else {
                  for (let j = 0; j < i; j++)
                    previousCardsCount += card_data?.[j]?.data?.length;
                }
                if (previousCardsCount >= 15) return null;
                return (
                  <>
                    <Collapse
                      // bordered={false}
                      className={`bg__white w-100 ${
                        ppt_generating_status
                          ? "border border-color"
                          : "border-0"
                      }`}
                      expandIconPosition="right"
                      defaultActiveKey={[i]}
                      onChange={onChange}
                      accordion
                      expandIcon={({ isActive }) =>
                        isActive ? <UpOutlined /> : <DownOutlined />
                      }
                    >
                      <Panel
                        className="custom_kpi w-100 border-bottom-0"
                        header={
                          <div className="text_regular font-weight500">
                            {d?.trace_name || allAttributes?.[d?.attribute]}{" "}
                            {`(${d?.data?.length}/${d?.no_of_cards})`}
                          </div>
                        }
                        key={i}
                        showArrow={
                          PdfDownloadStatus || ppt_generating_status
                            ? false
                            : true
                        }
                      >
                        <div
                          className={`flex-wrap d-flex gap-6 p-6 ${
                            type === "kpi" ? "bg__gray" : ""
                          } w-100`}
                        >
                          {widgetGraphConfig?.chart_type !== "kpi" &&
                            widgetGraphConfig?.chart_type !== "post-card" && (
                              <KpiCards
                                metaWidgetKpiData={metaWidgetKpiData}
                                widgetGraphConfig={widgetGraphConfig}
                                count={previousCardsCount}
                                cardPosition={cardPosition}
                                widgetShareOfData={widgetShareOfData}
                                widgetDurationComparison={
                                  widgetDurationComparison
                                }
                                type={type}
                                dashboard={dashboard}
                                PdfDownloadStatus={PdfDownloadStatus}
                                ppt_generating_status={ppt_generating_status}
                                widget_index={widget_index}
                                section_index={section_index}
                                kpi_data={d?.data}
                                noteExist={noteExist}
                                metaWidgetConfig={metaWidgetConfig}
                              />
                            )}
                        </div>
                      </Panel>
                    </Collapse>
                  </>
                );
              })}
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          {metaWidgetKpiData?.kpi?.length ? (
            <div
              className={`d-flex gap-6 p-6 ${
                type === "kpi" ? "bg__gray" : ""
              } flex-wrap w-100 wm-chart-cards ${
                cardPosition === "Bottom"
                  ? ""
                  : cardPosition === "Top"
                  ? ""
                  : ""
              } ${
                (cardPosition && cardPosition === "Left") ||
                cardPosition === "Right"
                  ? "custom_scroll1 card__list--scrollable"
                  : "justify-content-between"
              }`}
              style={
                type === "map" && (!PdfDownloadStatus || !ppt_generating_status)
                  ? { maxHeight: "calc(100vh - 16.5rem)" }
                  : PdfDownloadStatus || ppt_generating_status
                  ? { maxHeight: "68.5rem" }
                  : type !== "map" && dashboard && dashboard
                  ? ppt_generating_status
                    ? { maxHeight: "53.5rem" }
                    : cardPosition &&
                      (cardPosition === "Left" || cardPosition === "Right")
                    ? { maxHeight: "48rem" }
                    : {}
                  : {}
              }
            >
              <KpiCards
                metaWidgetKpiData={metaWidgetKpiData}
                widgetGraphConfig={widgetGraphConfig}
                count={count}
                cardPosition={cardPosition}
                widgetShareOfData={widgetShareOfData}
                widgetDurationComparison={widgetDurationComparison}
                type={type}
                dashboard={dashboard}
                PdfDownloadStatus={PdfDownloadStatus}
                ppt_generating_status={ppt_generating_status}
                widget_index={widget_index}
                section_index={section_index}
                kpi_data={metaWidgetKpiData?.kpi}
                noteExist={noteExist}
                metaWidgetConfig={metaWidgetConfig}
                isPreviewState={isPreviewState}
              />
            </div>
          ) : (
            ""
          )}
          {!metaWidgetKpiData && card_data?.length ? (
            <div
              className={`flex-wrap gap-6 p-6 ${
                type === "kpi" ? "bg__gray" : ""
              } w-100 wm-chart-cards d-flex ${
                cardPosition === "Bottom" ? "border-top border-color" : ""
              } ${
                (cardPosition && cardPosition === "Left") ||
                cardPosition === "Right"
                  ? "custom_scroll1 card__list--scrollable"
                  : "justify-content-between"
              }`}
            >
              {widgetGraphConfig?.chart_type !== "kpi" &&
                widgetGraphConfig?.chart_type !== "post-card" && (
                  <KpiCards
                    metaWidgetKpiData={metaWidgetKpiData}
                    widgetGraphConfig={widgetGraphConfig}
                    count={count}
                    cardPosition={cardPosition}
                    widgetShareOfData={widgetShareOfData}
                    widgetDurationComparison={widgetDurationComparison}
                    type={type}
                    dashboard={dashboard}
                    PdfDownloadStatus={PdfDownloadStatus}
                    ppt_generating_status={ppt_generating_status}
                    widget_index={widget_index}
                    section_index={section_index}
                    kpi_data={card_data}
                    noteExist={noteExist}
                    metaWidgetConfig={metaWidgetConfig}
                  />
                )}
            </div>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default React.memo(CardList, isEqual);
